import SelectedRegionController from './SelectedRegionController'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'
const mapDispatchToProps = dispatch => {
  return {
    setSelectedRegionId: selectedRegionId => dispatch(ReduxActions.setSelectedRegionId(selectedRegionId))
  }
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SelectedRegionController)
)



// WEBPACK FOOTER //
// ./src/modules/Controllers/SelectedRegion/SelectedRegionController/index.js